import { useTheme } from '@mui/material/styles';
import Logo from 'app/fuse-layouts/shared-components/Logo';
import Navigation from 'app/fuse-layouts/shared-components/Navigation';
import PublicNavbar from 'app/fuse-layouts/shared-components/PublicNavbar';
import clsx from 'clsx';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

function NavbarLayout2(props) {
	const theme = useTheme();
	const userId = useSelector(({ auth }) => auth.user.data?.userId);

	if (!userId) {
		return <PublicNavbar />;
	}

	return (
		<div
			className={clsx('w-full shadow-md', props.className)}
			style={{ backgroundColor: theme.palette.background.default, color: theme.palette.text.primary }}
		>
			<div
				className={clsx(
					'flex flex-auto justify-between items-center w-full h-full container p-0 lg:px-24 z-20'
				)}
			>
				<div className="flex flex-shrink-0 items-center px-8">
					<Logo />
				</div>

				<div className="flex h-full items-center overflow-hidden">
					<Navigation className="w-full" layout="horizontal" />
				</div>
			</div>
		</div>
	);
}

NavbarLayout2.propTypes = {
  className: PropTypes.string,
};

export default memo(NavbarLayout2);
